import "./styles.css";

import { mountBooking } from "./booking";
import { mountExperience } from "./experience";

mountExperience();
mountBooking();
